import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SearchExperience from "@/components/SearchExperience";
import SEOHead from "@/components/SEOHead";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd, titleCase } from "@/lib/seo";

export default function CityPage() {
  const { slug } = useParams();
  const [city, setCity] = useState({ name: titleCase(slug), state: "", stateSlug: "" });

  useEffect(() => {
    setCity({ name: titleCase(slug), state: "", stateSlug: "" });
    api.get("/cities").then((r) => {
      const m = (r.data.cities || []).find((c) => c.slug === slug);
      if (m) setCity({ name: m.name, state: m.state || "", stateSlug: m.stateSlug || "" });
    }).catch(() => {});
  }, [slug]);

  const path = `/city/${slug}`;
  const crumbs = [
    { name: "Home", path: "/" },
    ...(city.stateSlug ? [{ name: city.state, path: `/state/${city.stateSlug}` }] : []),
    { name: city.name, path },
  ];
  const jsonLd = [breadcrumbLd(crumbs)];
  const desc = `Explore colleges in ${city.name}${city.state ? `, ${city.state}` : ""}. Compare courses, fees and get free admission guidance.`;

  return (
    <>
      <SEOHead
        title={`Colleges in ${city.name} — Admissions & Courses`}
        description={desc}
        canonicalPath={path}
        jsonLd={jsonLd}
      />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <Breadcrumbs items={crumbs} />
      </div>
      <SearchExperience
        key={slug}
        lockedFilters={{ city: slug }}
        title={`Colleges in ${city.name}`}
        subtitle={`Institutions located in ${city.name}${city.state ? `, ${city.state}` : ""}.`}
      />
    </>
  );
}
